/**
 * @generated SignedSource<<6683cef2d4b578b39220269f3d61dff0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowInner_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow" | "useRowColorOld_rules">;
  readonly " $fragmentType": "RowInner_project";
};
export type RowInner_project$key = {
  readonly " $data"?: RowInner_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowInner_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isConditionalFormattingEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "useRowColorOld_rules"
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "8b4760a14bf514fa933f291ffc413e67";

export default node;
